import React from 'react';
import RichTextEditor from './TextEditorDraft';
import MyEditor from './QuillExperiment';

function AdminLessonDraft() {
  return (
    <div>
        <p>Draft JS Text editor</p>
        <MyEditor />
    </div>
  )
}

export default AdminLessonDraft